// Core proof — static story & role copy. Synthetic / illustrative.

export const STORY = [
  { n: "A", title: "Create the role pathway", who: "Centre Administrator", detail: "Define a bounded role relationship: role, onboarding pack, consent choices, permitted services and activation rule." },
  { n: "B", title: "Enter the private workspace", who: "Volunteer / Group Leader", detail: "Redeem a one-time link and see only your role, progress and support route." },
  { n: "C", title: "Profile & sharing choices", who: "Volunteer / Group Leader", detail: "Provide operational details and choose, in plain language, what is shared and what stays private." },
  { n: "D", title: "Activation", who: "Centre Administrator", detail: "The role is activated by the responsible authority — not as an automatic side effect of a form." },
  { n: "E", title: "Request a room or service", who: "Volunteer / Group Leader", detail: "Once active, request within permitted services, providing only what the Booking Administrator needs." },
  { n: "F", title: "Decision & evidence", who: "Booking Administrator", detail: "Assess and decide the request; a clear decision record with evidence is created." },
];

export const ROLE_CARDS = [
  {
    id: "centre_admin", label: "Centre Administrator", accent: "moss",
    who: "I set up and steward role relationships at The Mill.",
    holds: "The role pathway definitions, invitations and activation decisions.",
    can: "Create pathways, invite people, and activate or revoke roles.",
    approves: "I approve activation once onboarding is complete.",
    evidence: "A pathway record and an activation record naming me as the authority.",
  },
  {
    id: "volunteer", label: "Volunteer / Group Leader", accent: "blue",
    who: "I'm joining The Mill in a defined role.",
    holds: "My profile and any optional responses, in my private workspace.",
    can: "Complete onboarding, choose what to share, and request a room/service once active.",
    approves: "The Centre Administrator activates my role; the Booking Administrator answers my request.",
    evidence: "A record that I completed the onboarding pack and a sharing summary of my choices.",
  },
  {
    id: "booking_admin", label: "Booking Administrator", accent: "receipt",
    who: "I manage room and service requests.",
    holds: "The booking decisions and any conditions.",
    can: "Approve, request clarification, offer an alternative, redirect or decline with a reason.",
    approves: "I decide requests from active roles within their permitted services.",
    evidence: "A decision record showing the outcome, conditions and that I decided it.",
  },
];

export const PARKED = [
  { to: "/reference/overview", label: "Full canvas overview", note: "Personas, stages 0–4, success questions" },
  { to: "/journey/induction", label: "Volunteer induction", note: "v0.1 journey" },
  { to: "/journey/room-hire", label: "Room hire pipeline", note: "v0.1 journey" },
  { to: "/journey/activity-return", label: "Activity return & Prove/Improve", note: "v0.1 journey" },
  { to: "/journey/community-guide", label: "Ask The Mill (guided navigator)", note: "v0.2 — parked" },
  { to: "/journey/onboarding", label: "Onboarding console (v0.3)", note: "v0.3 — parked" },
];
